export const computeCharacterRanks = (characters) => {
  if (!Array.isArray(characters) || !characters.length) return [];

  return [...characters]
    .sort((a, b) => (b.pop || 0) - (a.pop || 0))
    .map((character, index) => ({
      ...character,
      rank: (index + 1).toString()
    }));
};

const loadRankedMap = async (service, batch = null) => {
  if (!service?.r2Service) return null;
  const cache = batch || {};
  if (!cache.mapPromise) {
    cache.mapPromise = (async () => {
      const allRankingsData = await service.r2Service.getCharacterRankings(true);
      if (!allRankingsData?.length) return new Map();
      const rankedCharacters = computeCharacterRanks(allRankingsData);
      return new Map(rankedCharacters.map((c) => [String(c.id), c.rank]));
    })();
  }
  try {
    return await cache.mapPromise;
  } catch (error) {
    cache.mapPromise = null;
    throw error;
  }
};

export const resolveCharacterRank = async (characterId, rankingsState, service, batch = null) => {
  if (rankingsState?.characters) {
    const stateChar = rankingsState.characters.find((c) => String(c.id) === String(characterId));
    if (stateChar?.rank) return stateChar.rank;
  }

  if (!service?.r2Service) return '?';

  try {
    const rankedMap = await loadRankedMap(service, batch);
    return rankedMap?.get(String(characterId)) || '?';
  } catch (error) {
    console.warn(`Failed to get rank for character ${characterId} from R2 service:`, error);
  }

  return '?';
};
